import { AI_TOOL_SELECT_USAGE_NOTE } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { searchPromptsInputSchema } from './botAiToolInputSchemas';

export { searchPromptsInputSchema };

export const searchPromptsOutputSchema = z.object({
  results: z
    .array(z.unknown())
    .describe(
      'Matching prompts. Default minimal mask: id, name, description, group, handle. Shape follows expanded flat `select` when provided.',
    ),
  count: z.number().int(),
});

export type SearchPromptsInput = z.infer<typeof searchPromptsInputSchema>;
export type SearchPromptsOutput = z.infer<typeof searchPromptsOutputSchema>;

export const searchPrompts: AiTool<undefined, SearchPromptsInput, SearchPromptsOutput> = {
  id: 'searchPrompts',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'READ',

  tool: tool({
    description: `Deprecated: prefer findPrompts with searchText. Search prompts by name (substring) and description/text (full-text / english stem). Does not search group or handle.

Returns id, name, description, group, and handle by default. ${AI_TOOL_SELECT_USAGE_NOTE}

By default **published and draft** prompts are returned. Pass \`onlyPublished: true\` to restrict to published prompts only.`,
    inputSchema: zodSchema(searchPromptsInputSchema),
    outputSchema: zodSchema(searchPromptsOutputSchema),
  }),
};
